import BudgetCalculator from "./BudgetCalculator";

export default BudgetCalculator;
